import React, { useState } from 'react';
import { convertToError } from '../../API/BaseApi';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react';
import { SerializedError } from '@reduxjs/toolkit';
import { Alert, Flex, Text, TextButton } from '@zillow/constellation';
import styled from 'styled-components';

interface ErrorAlertProps {
  error?: Error;
  rtkError?: FetchBaseQueryError | SerializedError;
}

export const ErrorAlertConstellation: React.FC<ErrorAlertProps> = ({ error, rtkError }) => {
  const [showStackTrace, setShowStackTrace] = useState<boolean>(false);
  const err: Error | undefined = convertToError(rtkError) ?? error;

  if (!err) {
    return null;
  }

  return (
    <Alert
      appearance={'error'}
      body={<ErrorBody showStackTrace={showStackTrace} err={err} />}
      actionButton={
        err.stack && (
          <TextButton onClick={() => setShowStackTrace((prevState) => !prevState)}>
            {`${showStackTrace ? 'Hide' : 'Show'} Stack Trace`}
          </TextButton>
        )
      }
    />
  );
};

const ErrorBody: React.FC<{ message?: React.ReactNode; err?: Error; showStackTrace: boolean }> = ({
  err,
  showStackTrace,
}) => {
  return (
    <Flex display={'flex'} flexDirection={'column'} gap={'sm'}>
      <Text>{err?.message ?? 'Pinecone has encountered an error.'}</Text>
      {showStackTrace && <Code role={'note'}>{err?.stack}</Code>}
    </Flex>
  );
};

const Code = styled('code')`
  white-space: pre-line;
  overflow-wrap: break-word;
`;
